import { useState } from "react";
import { Tag } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { LeadTagSelector } from "@/components/leads/LeadTagSelector";
import { useLeadTags } from "@/hooks/useLeadTags";

interface LeadTagsPopoverProps {
  workspaceId: string;
  leadId: string;
  compact?: boolean;
  hideTrigger?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function LeadTagsPopover({
  workspaceId,
  leadId,
  compact = false,
  hideTrigger = false,
  open: controlledOpen,
  onOpenChange: controlledOnOpenChange,
}: LeadTagsPopoverProps) {
  const [internalOpen, setInternalOpen] = useState(false);
  const open = controlledOpen ?? internalOpen;
  const setOpen = controlledOnOpenChange ?? setInternalOpen;
  const { leadTags } = useLeadTags({ workspaceId, leadId });

  return (
    <Popover open={open} onOpenChange={setOpen}>
      {!hideTrigger ? (
        <PopoverTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            type="button"
            title="Tags do lead"
            className={cn(
              compact ? "h-7 w-7" : "h-8 w-8",
              "flex-shrink-0",
              leadTags.length > 0 && "text-primary"
            )}
          >
            <Tag className={compact ? "w-3.5 h-3.5" : "w-4 h-4"} />
          </Button>
        </PopoverTrigger>
      ) : null}
      <PopoverContent className="w-72 p-3" align="end" sideOffset={8}>
        <p className="mb-2 text-xs font-medium text-muted-foreground">
          Tags do lead
        </p>
        <LeadTagSelector workspaceId={workspaceId} leadId={leadId} />
      </PopoverContent>
    </Popover>
  );
}
